export default __webpack_public_path__ + "static/media/img1.1b005d5e.jpg";